<template>
    <div class="page-content">
        <div id="impressum" class="section grow pt-5 pb-5 bg-eggshell">
            <div class="container h-100">
                <div class="d-flex h-100 text-left align-items-center">
                    <div class="w-100">
                        <termly-policy termlyDataId="579fe1e2-5cb7-4715-a1ff-e1300fce6add"></termly-policy>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'impressum',
  metaInfo: {
      title: 'Impressum'
  },
  components: {
  },
  mounted(){
  }
}
</script>
